import BotResponseTreeNode from './BotResponseTreeNode';
import SlotDisplayCondition from './SlotDisplayCondition';

class SendSmsTreeNode {
  phoneNumber: string;

  content: string;

  nextStep: BotResponseTreeNode | null;

  slotDisplayConditions: SlotDisplayCondition[];

  constructor(
    phoneNumber: string,
    content: string,
    nextStep: BotResponseTreeNode | null,
    slotDisplayConditions: SlotDisplayCondition[]
  ) {
    this.phoneNumber = phoneNumber;
    this.content = content;
    this.nextStep = nextStep;
    this.slotDisplayConditions = slotDisplayConditions;
  }
}

export default SendSmsTreeNode;
